import { render, staticRenderFns } from "./AboutMembersHeader.vue?vue&type=template&id=6d07b3b2&"
import script from "./AboutMembersHeader.vue?vue&type=script&lang=js&"
export * from "./AboutMembersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports